import { allTrue } from '../../utils/fn'
import { info } from '../../application/console'
import { queryString as qs } from '../../utils/window'
import { getIsNativeApp, getIsMobile, path } from '../../utils/ua'
import { getSite } from '../../application/pageDataObject'
import { scriptLoadingStart, scriptLoadingEnd } from '../actions/browsiActions'
import { referringDomain } from '../../utils/dom'
import { getInfluencerId } from '../../utils/pageContext'

const { isEmbedded } = path
const FEATURE_FLAGS = {
  forceBrowsi: qs.forceBrowsi,
  debug: qs.debugBrowsi,
}
const BROWSI_ALLOWED_DOMAINS = ['90min', '12up', 'dbltap', 'floor8', 'german_site', 'theduel']
const BROWSI_AFFID_BY_DOMAIN = {
  '12up': '12up',
  '90min': '90min',
  floor8: 'floor8',
  dbltap: 'dbltap',
  german_site: '90min',
  theduel: 'theduel',
}

const SCRIPT = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js'

const BROWSI_ALLOWED_UTM_SOURCES = ['facebook']
const BROWSI_ALLOWED_REFERRALS = ['facebook.com']

const affiliateId = getInfluencerId() // eslint-disable-line camelcase

//yoni TODO - delete it by 1/5/18
// function hasAllowedReferral() {
//   const externalReferrer = referringDomain()
//   return BROWSI_ALLOWED_REFERRALS.some(externalReferrer.includes, externalReferrer)
// }

// function hasAffiliateId() {
//   return affiliateId !== true && !!affiliateId
// }

function getUtmSource() {
  return qs.utm_source || 'NO_UTM_SOURCE'
}

function hasAllowedUtmSource(utmSource = getUtmSource()) {
  return BROWSI_ALLOWED_UTM_SOURCES.some(utmSource.includes, utmSource)
}

function hasWhitelistQuerystring() {
  return hasAllowedUtmSource()
}

function debug() {
  if (FEATURE_FLAGS.debug) {
    info('[browsi]', ...arguments)
  }
}

export function isBrowsiEnabled() {
  const predicates = [
    getIsMobile(),
    !getIsNativeApp(),
    BROWSI_ALLOWED_DOMAINS.includes(getSite()),
    // hasWhitelistQuerystring(),
  ]
  const shouldLoadBrowsi = FEATURE_FLAGS.forceBrowsi || allTrue(...predicates)
  debug('isBrowsiEnabled?', shouldLoadBrowsi, { predicates })
  return shouldLoadBrowsi
}

function beforeLoad() {
  debug('before script load')
  debug('browsi script src', SCRIPT)
  scriptLoadingStart()
}

function onload() {
  // eslint-disable-line no-shadow
  debug('on script load')
  scriptLoadingEnd()
}

export const browsiScriptConfig = {
  name: 'browsi',
  src: SCRIPT,
  id: 'browsi-tag',
  'data-pubKey': 'minutemedia',
  'data-siteKey': BROWSI_AFFID_BY_DOMAIN[getSite()],
  beforeLoad,
  onload,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/browsiScriptConfig.js